import { Navigate, useParams } from 'react-router-dom'
import { STAFF_IDM_ROUTE, STAFF_ROUTE } from '../../app/router/routes'

export default function IdmPage() {
    const {id} = useParams<{id: string}>()
    const target = id
        ? STAFF_IDM_ROUTE.path.replace(':user_id', id)
        : STAFF_ROUTE.path

    return <Navigate to={target} replace />
}
